import { graphql } from "@/lib/gql/__generated__";

export const Snack_SnackEditPage_Query = graphql(`
	query Snack_SnackEditPage($hotelID: ID!, $uuid: ID!) {
		hotel(hotelID: $hotelID) {
			companyID
		}
		snack(hotelID: $hotelID, uuid: $uuid) {
			id
			uuid
			snackType
			hotelID
			ownerType
			isPublished
			isParentTemplate
			slug
			title
			description
			thumbnail
			snack {
				bucket
				key
				region
				mimeType
				fileName
			}
			availablePlansForHotel
			createdAt
			updatedAt
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				id
				hotelID
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				name
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}

		roomList(hotelID: $hotelID) {
			id
			hotelID
			rooms {
				id
				hotelID
				roomID
				inSale
				name
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				saleTypeForPlan
			}
			# dummy {
			# 	id
			# 	hotelID
			# 	roomID
			# 	inSale
			# 	maxRoomNum
			# 	name
			# }
		}
		snackListParentTemplate {
			id
			snacks {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
		snackListSystemTemplate {
			id
			snacks {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
		snackList(hotelID: $hotelID) {
			id
			snacks {
				id
				uuid
				snackType
				hotelID
				ownerType
				isPublished
				isParentTemplate
				slug
				title
				description
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
				availablePlansForHotel
				createdAt
				updatedAt
			}
		}
		snackTemplateSystem {
			id
			hotelID
			uuid
			templateCategoryMasts {
				uuid
				title
				snackUUIDs
			}
			createdAt
			updatedAt
			deletedAt
		}
	}
`);
